import { useContent } from "@/context/ContentContext";
import { CONTACT } from "@/data/site";

const display = (digits) => (digits.length === 10 ? `+91 ${digits.slice(0, 5)} ${digits.slice(5)}` : digits);

/** Contact details with admin overrides (Website Text > Contact details). */
export function useContact() {
  const { texts } = useContent();
  const phone = (texts["contact.phone"] ?? CONTACT.phone).replace(/\D/g, "").replace(/^91(?=\d{10}$)/, "");
  const changed = phone !== CONTACT.phone;
  return {
    ...CONTACT,
    phone,
    phoneDisplay: changed ? display(phone) : CONTACT.phoneDisplay,
    email: texts["contact.email"] ?? CONTACT.email,
    address: texts["contact.address"] ?? CONTACT.address,
    whatsapp: changed ? `https://wa.me/91${phone}?text=Hi%20Trippy%20Tastic%2C%20I%20have%20a%20query!` : CONTACT.whatsapp,
  };
}
